<template>
    <div>
        <!-- tax-rate start -->
        <div class="p-0 pl-sm-4 m-0">
            <b-overlay :show="loading" class="round-unify my-4">
                <div class="bg-white round-unify p-4">
                    <b-form ref="tax-rate-form" class="d-flex flex-column">
                        <b-form-group
                            id="input-group-tax-type"
                            :label="$t('labels.taxtype')"
                            label-for="tax-type-selector"
                            label-class="label-align"
                        >
                            <b-form-select
                                id="tax-type-selector"
                                class="rounded-pill"
                                v-model="form.Type"
                                :options="taxType"
                                disabled
                                required
                            ></b-form-select>
                        </b-form-group>

                        <b-form-group
                            id="input-group-name"
                            :label="$t('labels.name')"
                            label-for="input-name"
                            aria-describedby="name-description"
                            label-class="label-align"
                        >
                            <b-form-input
                                id="input-name"
                                v-model="form['DisplayName']"
                                type="text"
                                required
                                :placeholder="$t('placeholders.taxratename')"
                                class="rounded-pill"
                            ></b-form-input>
                            <b-form-text id="name-description" class="ml-3">{{
                                $t('messages.taxRateDisplayNameHelp')
                            }}</b-form-text>
                        </b-form-group>

                        <b-form-group
                            id="input-group-description"
                            :label="$t('labels.descriptionoptional')"
                            label-for="input-description"
                            label-class="label-align"
                        >
                            <b-form-textarea
                                id="input-description"
                                :placeholder="$t('placeholders.textoptional')"
                                rows="3"
                                style="border-radius: 1rem"
                                v-model="form.Description"
                            ></b-form-textarea>
                            <b-form-text>
                                {{ $t('messages.taxRateDescriptionHelp') }}
                            </b-form-text>
                        </b-form-group>

                        <b-form-group
                            id="input-group-rate"
                            :label="$t('labels.rateinpercent')"
                            label-for="input-rate"
                            aria-describedby="rate-description"
                            label-class="label-align"
                        >
                            <b-form-input
                                id="input-rate"
                                v-model="form.Percentage"
                                number
                                disabled
                                required
                                class="rounded-pill"
                                step="0.01"
                            ></b-form-input>
                            <b-form-text id="rate-description" class="ml-3">{{
                                $t('messages.taxRatePercentHelp')
                            }}</b-form-text>
                        </b-form-group>

                        <b-form-group
                            id="input-group-type"
                            :label="$t('labels.ratetype')"
                            label-for="type-selector"
                            aria-describedby="type-description"
                            label-class="label-align"
                        >
                            <b-form-select
                                id="type-selector"
                                class="rounded-pill"
                                v-model="form.Inclusive"
                                :options="rateType"
                                required
                                disabled
                            ></b-form-select>
                            <b-form-text id="type-description">
                                {{ $t('messages.taxRateTypeHelp') }}
                            </b-form-text>
                        </b-form-group>

                        <b-form-group
                            id="input-group-region"
                            :label="$t('labels.region')"
                            label-for="input-region"
                            label-class="label-align"
                        >
                            <b-form-select
                                id="select-region"
                                v-model="form.Country"
                                required
                                disabled
                                class="form-control rounded-pill d-block"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled selected>{{
                                        $t('placeholders.selectcountry')
                                    }}</b-form-select-option>
                                </template>
                                <b-form-select-option :value="item.Alpha2" v-for="(item, _) in countries">{{
                                    item.Name
                                }}</b-form-select-option>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group
                            id="input-group-active-checkbox"
                            :label="$t('labels.active')"
                            label-for="active-checkbox"
                            label-class="label-align"
                        >
                            <b-form-checkbox id="active-checkbox" v-model="form.Active" size="md" :value="true">
                                <p class="mb-0">{{ $t('messages.taxRateActive') }}</p>
                            </b-form-checkbox>
                            <b-form-text>
                                {{ $t('messages.taxRateActiveHelp') }}
                            </b-form-text>
                        </b-form-group>

                        <div class="d-flex justify-content-between mt-4">
                            <b-button
                                variant="outline-danger"
                                type="button"
                                @click="
                                    hasHistory()
                                        ? $router.go(-1)
                                        : $router.push('/admin/monetization/payments/tax-rate')
                                "
                                >{{ $t('labels.cancel') }}</b-button
                            >
                            <b-button variant="primary" type="button" @click="update">{{ $t('labels.save') }}</b-button>
                        </div>
                    </b-form>
                </div>
            </b-overlay>
        </div>
        <!-- tax-rate end -->
    </div>
</template>

<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>

<script>
import axios from 'axios';
import EventBus from '@/eventBus';

export default {
    name: 'EditTaxRate',
    components: {},
    data() {
        return {
            id: this.$route.params.ID,

            form: {
                Inclusive: false,
                Percentage: 19.0,
                Active: true,
                Type: 'VAT',
                Country: null,
            },
            loading: false,

            taxType: [{ value: 'VAT', text: this.$t('labels.vat') }],
            rateType: [
                { value: true, text: this.$t('labels.inclusive') },
                { value: false, text: this.$t('labels.exclusive') },
            ],

            countries: [],
        };
    },
    mounted() {
        this.getTaxRate();
        this.listContries();
    },

    methods: {
        hasHistory() {
            return window.history.length > 2;
        },

        getTaxRate() {
            this.loading = true;
            axios({
                method: 'GET',
                url: `/admin/tax-rate/${this.id}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.form = response.data;
                        this.form.Type = 'VAT';
                        if (!this.form.Inclusive) {
                            this.form.Inclusive = false;
                        }
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.taxRateLoadFailed'),
                        Details: error,
                    });
                    this.loading = false;
                });
        },
        update() {
            if (this.$refs['tax-rate-form'].checkValidity()) {
                this.putTaxRate();
            } else {
                this.$refs['tax-rate-form'].reportValidity();
            }
        },

        putTaxRate() {
            this.loading = true;
            const object = this.form;
            object.Jurisdiction = object.Country;

            axios({
                method: 'PUT',
                url: '/admin/tax-rate',
                data: object,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.taxRateUpdated'),
                        Details: '',
                    });
                    this.loading = false;
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.taxRateUpdateFailed'),
                        Details: error,
                    });
                    this.loading = false;
                });

            this.loading = false;
        },

        listContries() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/space/countries',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.countries = response.data;
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.countriesLoadFailed'),
                        Details: error,
                    });
                    this.loading = false;
                });
        },
    },
};
</script>
